import { render, staticRenderFns } from "./SummitPopup.vue?vue&type=template&id=27bd2a48&scoped=true&"
import script from "./SummitPopup.vue?vue&type=script&setup=true&lang=js&"
export * from "./SummitPopup.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SummitPopup.vue?vue&type=style&index=0&id=27bd2a48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bd2a48",
  null
  
)

export default component.exports